<div [class]="gridClass()">
  <div [class]="imageClass()"><app-image [image]="image"></app-image><app-caption *ngIf="caption" [caption]="caption"></app-caption></div>
  <div [class]="textClass()"><app-text [content]="content" [notCentered]="true"></app-text></div>
</div>
